import React, { useState, useMemo, useEffect } from 'react';
import EditableTable from '../editableTable/EditableTable';
import Person from '../../data/schemas/person';
import Group from '../../data/schemas/group';

const Rooming = ({ rooming = [], onRoomingUpdate, onRoomingTypeChanged, type: initialGrouped = false, pax = 1 }) => {

    const [grouped, setGrouped] = useState(initialGrouped);

    // Synchroniser l'état local si la prop change (ex: lors du chargement d'un dossier)
    useEffect(() => {
        setGrouped(initialGrouped);
    }, [initialGrouped]);

    // Stabilisation des références pour éviter les re-rendus inutiles d'EditableTable
    const personReference = useMemo(() => new Person(), []);
    const groupReference = useMemo(() => new Group(null, pax), [pax]);
    const civiliteChoices = useMemo(() => ({ civilite: ['Mr', 'Mme'] }), []);

    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
                <span style={{ fontWeight: 500 }}>Rooming group ?</span>
                <input
                    type="checkbox"
                    checked={grouped}
                    onChange={() => {
                        onRoomingUpdate([]);
                        const next = !grouped;
                        setGrouped(next);
                        if (onRoomingTypeChanged) onRoomingTypeChanged(next);
                    }}
                    style={{ width: 18, height: 18, cursor: 'pointer' }}
                />
            </div>

            {grouped
                ? <EditableTable key="grouped" reference={groupReference} data={rooming} onUpdate={onRoomingUpdate} />
                : <EditableTable key="individual" reference={personReference} data={rooming} choices={civiliteChoices} onUpdate={onRoomingUpdate} />
            }
        </div>
    );
};

export default Rooming;
